module.exports = __webpack_public_path__ + "media/fonts/american_typewriter-webfont-a9a72101a12651d530f031c6e55da38c.svg";